import { FilterCheckbox } from '$components/Internal/Positions/Filters/FilterCheckbox';
import FilterSelect from '$components/Internal/Positions/Filters/FilterSelect/FilterSelect';
import { ReactComponent as Search } from '$icons/SearchIcon.svg';
import Button from '$components/Buttons/Button';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OpenToWorkTypes, QualityStatusTypes } from '$types/candidates.d';
import FilterMultiSelectWithGroups from '$components/Internal/Positions/Filters/FilterMultiSelectWithGroups/FilterMultiSelectWithGroups';
import { GroupedCountries } from '$constants/countries';
import { FilterInput } from '$components/Internal/Positions/Filters/FilterInput';

const SearchCandidatesFilter = () => {
  const searchTypes = [
    { text: 'Everything', id: 'Everything' },
    { text: 'Job Title', id: 'Job Title' },
    { text: 'Skills', id: 'Skills' },
  ];

  const fileCategories = [
    { id: 'Video', text: 'Video' },
    { id: 'CV', text: 'CV' },
    { id: 'Reference', text: 'Reference' },
  ];

  const qualityStatusOptions = (
    Object.keys(QualityStatusTypes) as Array<keyof typeof QualityStatusTypes>
  ).reduce((prev, act) => {
    const tempQualityStatus = {
      id: QualityStatusTypes[act],
      text: QualityStatusTypes[act],
    };
    prev.push(tempQualityStatus);
    return prev;
  }, [] as { id: string; text: string }[]);

  const openToWorkOptions = (
    Object.keys(OpenToWorkTypes) as Array<keyof typeof OpenToWorkTypes>
  ).reduce((prev, act) => {
    const tempOpenToWork = {
      id: OpenToWorkTypes[act] as string,
      text: OpenToWorkTypes[act] as string,
    };
    prev.push(tempOpenToWork);
    return prev;
  }, [] as { id: string; text: string }[]);

  const [t] = useTranslation('global');
  const [showSearch, setShowSearch] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [type, setType] = useState(searchParams.get('Type') || 'Everything');

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('Type', type);
    setSearchParams(newParams);
  }, [searchParams, setSearchParams, type]);

  return (
    <div className="flex flex-row items-start">
      <div
        className={`${
          showSearch ? 'w-60' : 'w-0 overflow-hidden'
        } flex flex-col gap-4 rounded-r bg-white transform transition-all border-r-2 border-t-2 border-b-2 sticky top-0`}
      >
        <div className="p-4 flex flex-col gap-4">
          <FilterSelect
            title="Type"
            setCategory={setType}
            options={searchTypes}
            placeholder={type}
            hideNoneOpt
          />
          <FilterMultiSelectWithGroups
            title={t('Filters.country')}
            data={GroupedCountries}
            hideUnknownCheckbox
          />
          <FilterInput
            title={t('SearchCandidates.Filters.Salary')}
            nameField
            regexValidation={/^\d+$/gi}
            validationErrorMessage={t('SearchCandidates.Filters.InvalidSalary')}
          />
          <FilterCheckbox
            title={t('SearchCandidates.Filters.Files')}
            options={fileCategories}
          />
          <FilterCheckbox
            title={t('SearchCandidates.Filters.QualityStatus')}
            options={qualityStatusOptions}
          />
          <FilterCheckbox
            title={t('SearchCandidates.Filters.OpenToWork')}
            options={openToWorkOptions}
          />
        </div>
      </div>
      <div className="w-12 z-10 -ml-[2px] px-2 bg-white rounded-r whitespace-nowrap border-r-2 border-t-2 border-b-2 sticky top-0">
        <Button
          icon={Search}
          iconStyles={{ className: 'w-6 h-6' }}
          onClick={() => setShowSearch((prev) => !prev)}
        />
      </div>
    </div>
  );
};

export default SearchCandidatesFilter;
